<template>
  <transition name="fade">
    <div id="product-details" v-show="view">
      <div id="box-container">
        <div class="close-btn" @click="closeDetail"><i class="fa fa-times"></i></div>
        <div id="flex-container">
          <div class="discount" v-show="showDiscount">{{ showDiscount }}</div>
          <div class="flex-item" id="raw">
            <img :src="bigImage" class="image-detail">
          </div>
          <div class="raw-item" id="flex">
            <div class="info">
              <p class="small-sku">SKU {{ data.sku }}</p>
              <h2 class="title">{{data.title}}</h2>
              <p class="description" v-if="data.description != ''">{{data.description}}</p>
              <div class="more-details" v-if="data.sale > 0">
                <div class="cash">
                  <div class="price" v-show="data.price && data.price != data.sale">Antes <span>${{data.price}}</span></div>
                  <div class="sale">${{data.sale}}</div>
                </div>
                <div class="financed" v-show="data.fee > 0">
                  <div class="card"><img src="static/img/tc.jpg" width="50"></div>
                  <div class="financed-txt">
                  <div class="fee">{{data.fee}} cuotas <span v-if="data.fee != null && data.pft == null">s/interés</span> de</div>
                  <div class="fee-price" v-html="feePrice"></div>
                  <div class="pft" v-if="data.ptf != null">${{data.pft}}</div>
                  </div>
                </div>
              </div>
              <a @click="trackClick" :href="data.link ? data.link : 'https://www.easy.com.ar/webapp/wcs/stores/servlet/es/SearchDisplay?storeId=10151&catalogId=10051&langId=-5&pageSize=12&beginIndex=0&searchSource=Q&sType=SimpleSearch&resultCatEntryType=2&showResultsPage=true&pageView=image&searchTerm='+data.sku" class="go-btn" target="_blank">Comprar</a>
              <div class="legal" v-show="data.legal !== ''">{{data.legal}}</div>
            </div>
            <div v-if="data.related.length > 0" class="related-products">
              <h4>También te puede interesar</h4>
              <carousel :perPage="$parent.isMobile ? 3 : 4" paginationPadding="10">
                <slide v-for="(related,index) in data.related" :key="index">
                  <img :src="relatedImage(related)" width="100" @click="openRelated(related)">
                </slide>
              </carousel>
            </div>
          </div>
        </div>
      </div>
    </div>
  </transition>
</template>
<script>
/* eslint-disable */
const axios = require('axios')
import { Carousel, Slide } from 'vue-carousel';
export default {
  name: 'DetilsComponent',
  props: {
    view: Boolean,
    data: Object
  },
  computed: {
    feePrice() {
      let fee_price = String((this.data.sale / this.data.fee).toFixed(2))
      fee_price = fee_price.split('.')
      return `$${fee_price[0]},<sup>${fee_price[1]}</sup>`
    },
    showDiscount () {
      if (this.data.discount) {
        let discount = this.data.discount.toLowerCase()
        console.log(discount)
        switch (discount) {
          case 'superprecio':
            discount = 'SUPER\nPRECIO'
            break
          case '4x3':
          case '2x1':
          case '6x4':
          case '3x2':
          case '5x4':
            break
          case '':
            discount = null
            break
          default:
            discount = discount + '%'
            console.log('default')
            break
        }
        return discount
      } else {
        return null
      }
    },
    bigImage () {
      let big = this.data.image ? this.data.image.replace('?$Mini$','') : null
      return big//ok ? big : 'static/img/sin-imagen.jpg'
    }
  },
  data () {
    return {
      test: 'Test'
    }
  },
  methods: {
    trackClick(){
      dataLayer.push({
        'event': 'Interacción', // Acá se deja como evento de interacción
        'category': 'Modal', // Hay que dejarlo como un evento de modal
        'action': 'COMPRAR',//{X/Comprar}, // Se registra la acción como un clic, con lo que se                                                  seleccionó
        'tag': this.data.title // Nombre del producto abierto en el modal
      })
    },
    relatedImage(sku){
      return this.$parent.productsData[sku].image
      //console.log(sku)
      //console.log(this.$parent.$parent.$parent.productsData[sku])
      //return this.$parent.$parent.$parent.productsData[sku]
    },
    openRelated(sku){
      this.data = this.$parent.productsData[sku]
    },
    closeDetail () {
      this.$parent.viewDetail = false
      dataLayer.push({
        'event': 'Interacción', // Acá se deja como evento de interacción
        'category': 'Modal', // Hay que dejarlo como un evento de modal
        'action': 'X',//{X/Comprar}, // Se registra la acción como un clic, con lo que se                                                  seleccionó
        'tag': this.data.title // Nombre del producto abierto en el modal
      })
    }
  },
  components: {
    Carousel,
    Slide
  }
}
function checkImage(url) {
  var request = new XMLHttpRequest();
  request.open("GET", url, true);
  request.send();
  request.onload = function() {
    status = request.status;
    if (request.status == 200) //if(statusText == OK)
    {
      console.log("image exists");
    } else {
      console.log("image doesn't exist");
    }
  }
}
</script>
<style>
.VueCarousel-dot-container{margin-top:-20px!important;}
.related-products{margin-top:30px;}
.related-products .related-list{ 
  list-style:none;
  padding:0px;
  margin:0px;
  cursor:pointer;
  width:55%;
  height:135px;
  overflow-y:hidden;
  overflow-x:auto;
  white-space:nowrap;
}
.related-products li.related-item{display:inline-block;padding:5px;}
  #product-details { background-color: #fff;width: 100%;height: calc(100vh) !important;position: fixed;top:0;z-index: 103;overflow-y:scroll}
  .close-btn {font-size: 2em;display: block;position: absolute;right: 20px;top: 15px;}
  .fade-enter-active, .fade-leave-active {
    transition: opacity .5s
  }
  .fade-enter, .fade-leave-to {
    opacity: 0
  }
  .image-detail{max-width:90%;margin: 35px auto auto;margin-top:35px;min-height: 30vh;
    max-height: 40vh;}
  #product-details .small-sku{font-size:0.700em;margin:0px;text-align:center;font-style:italic}
  #product-details .title{font-family: 'Montserrat', sans-serif;font-size: 1.250em;line-height:1.150em;text-align: center;font-weight: 600;padding:0px 10px;margin-top:10px;margin-bottom:0px;}
  #product-details .description{margin-top:5px}
  .VueCarousel{width:50vh;margin-left: auto;margin-right: auto;}
  #product-details .price{font-family: 'Montserrat', sans-serif;font-size: 0.950em;text-align: center;color:#666;}
  #product-details .price span{text-decoration: line-through;}
  #product-details .sale{font-family: 'Montserrat', sans-serif;font-size: 1.850em;text-align: center;font-weight: 600;color:#000}
  #product-details .legal{position:fixed;bottom:85px;background-color:#fff;font-size:0.650em;padding:5px;font-style:italic;width:90%;margin-left:5%;}
  #product-details .go-btn{position:relative;text-decoration:none;margin-top:30px;display:inline-block;background-color: #f9bb10;border: none;border-radius: .5em;color: #473d38;font-weight: 700;font-size:1em;width: 200px;padding: 1em 0;height: 15px;line-height:15px;}
  #product-details .discount {position: absolute;top: 30px;left: 0px;width: 103px;height: 80px;line-height: 80px;border-radius: 0px;border-top-right-radius: 50px;border-bottom-right-radius: 50px;font-size: 2em;font-family: 'Montserrat', sans-serif;font-weight: 800;box-shadow: 0px 2px 2px 0px #00000040;background-color:#ed2424;color:#fff}
  .financed{margin-top:20px}
  .fee,.fee-price{font-family: 'Montserrat', sans-serif;color:#ed2424;font-size:0.850em}
  .fee-price{font-family: 'Montserrat', sans-serif;font-size:1.500em}
  .fee-price sup{font-size:0.650em!important}
  .pft{font-family: 'Montserrat', sans-serif;color:#ed2424}
  .card,.financed-txt{display:inline-block;vertical-align:middle}
  @media only screen and (min-width: 1000px) {
    .VueCarousel{width:70vh}
    .related-products{text-align:left;}
    #product-details .small-sku{font-family: 'Montserrat', sans-serif;font-size:0.700em;margin:0px;text-align:left;font-style:italic}
    #product-details {background-color:rgba(0,0,0,0.8)}
    #product-details .info{ width:400px}
    #box-container {background-color: #fff;width: 1000px;height: 560px;top: 50%;margin-top: -280px;left: 50%;margin-left: -500px;position: relative;}
    .image-detail {max-width:80%!important;margin-top:0px!important;min-height:auto!important;max-height:auto!important}
    #product-details .title{color:#000;font-size:1.250em;margin-bottom:0px;margin-top:5px;text-align:left;padding:0px 0px;}
    #product-details p.description{color:#666;font-size:0.950em;margin-top:0px;text-align:left;}  
    #product-details .go-btn{margin-top:20px;}
    #flex-container {display: -webkit-box;display: -ms-flexbox;display: flex;-webkit-box-orient: horizontal;-webkit-box-direction: normal;-ms-flex-direction: row;align-items: center;flex-direction: row;height: 560px;}
  #flex-container > .flex-item {-webkit-flex: auto;flex: auto;min-width: 500px;}
   #flex-container > .raw-item {width: 100%;}
   .more-details{border-top:solid thin #ccc;border-bottom:solid thin #ccc; display:-webkit-box;display:-ms-flexbox;display:flex;-webkit-box-orient: horizontal;-webkit-box-direction: normal;-ms-flex-direction: row;align-items: center;flex-direction: row;padding:10px 0px}
  .financed{margin-top:0px}
  .cash,.financed{-webkit-flex: auto;flex:auto;}
  .financed .card{display:inline-block;vertical-align: middle;}
  .financed .financed-txt{display:inline-block;vertical-align: middle;}
  }
</style>



// WEBPACK FOOTER //
// src/components/DetailsComponent.vue